import { Box, Link } from "@mui/material";
import { FC } from "react";
import ReactMarkdown from "react-markdown";
import { FEATURES } from "../../../../constants";
import { useHasFeature } from "../../../../hooks/feature/useHasFeature";
import { ExternalLink } from "../../../../icons/external-link";
import { axiosInstance } from "../../../../services/axios";
import SectionCard from "../../../common/sectionCard";
import { IssueFixButton } from "./IssueView";
import SequenceStep from "./SequenceStep";
import ReactMarkdownStyled from "../../../common/reactMarkdownStyled";
const jp = require("jsonpath")
var format = require("string-template");

interface IWidgetParameterDefinition {
    type: "const" | "keyPath",
    value: any
}

const getWidgetValue = (source: any, definition: IWidgetParameterDefinition) => {

    try {
        const { type, value } = definition
        if (type === "const") {
            return value
        }

        if (type === "keyPath") {
            let query = jp.query(source, "$." + value)

            return query[0]
        }
    }
    catch (e) {
        console.log(e)
    }
    return
}

interface IWidgetHandler {
    widget: any,
    info: any
}
const WidgetHandler: FC<IWidgetHandler> = ({ widget, info }) => {
    const { widget: type } = widget

    if (type === "info") {
        return <InfoWidget widget={widget} info={info} />
    }

    if (type === "text") {
        return <TextWidget widget={widget} info={info} />
    }

    if (type === "code_fix") {
        return <SuggestFixWidget widget={widget} info={info} />
    }

    if (type === "sequence") {
        return <SequenceWidget widget={widget} info={info} />
    }
    return <></>
}

const InfoWidget: FC<any> = ({ widget, info }) => {
    const { finding, issue, result } = info;
    if (!getWidgetValue(finding, widget?.name?.text)) {
        return null
    }

    return <SectionCard title={getWidgetValue(finding, widget?.name?.title)}
        children={<Box sx={{ py: 1.5 }}>
            {getWidgetValue(finding, widget?.name?.text)}
        </Box>} />

}

const TextWidget: FC<any> = ({ widget, info }) => {
    const { finding, issue } = info
    if (!getWidgetValue(finding, widget?.data?.text)) {
        return null
    }
    return <SectionCard title={getWidgetValue(finding, widget?.data?.title)} children={<Box>
        {(() => {
            try {
                //@ts-ignore
                return (
                    <ReactMarkdownStyled
                        markdown={getWidgetValue(finding, widget?.data?.text)} />
                    
                );
            } catch (error) {
                return "";
            }
        })()}
    </Box>} />

}

const SuggestFixWidget: FC<any> = ({ widget, info }) => {
    const { finding, issue } = info
    const hasAIPermissions = useHasFeature(FEATURES.AI_TRIAGE)

    if (!hasAIPermissions) {
        return <></>
    }

    return <SectionCard title="Code Fix" children={
        <Box sx={{pb:1, pt:2}}>

            <IssueFixButton issueId={issue?.id} />
        </Box>}/>

    

}


const SequenceWidget: FC<any> = ({ widget, info }) => {
    const { finding, issue } = info

    const handleExport = async () => {
        try {
            console.log(finding.findingDetail);
            let id = finding.findingDetail.id;
            let response = await axiosInstance.get(
                format(`/findings/{id}/sequence/export`, { id: id })
            );
            const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
                JSON.stringify(response?.data)
            )}`;

            const link = document.createElement("a");
            link.href = jsonString;
            link.download = `${id}.har`;
            link.click();
        } catch (error) { }
    };

    return <SectionCard title={<Box sx={{ display: "inline-flex", alignItems: "center" }}>
        Sequence

        <Box
            className="hand"
            sx={{ display: "inline-flex", alignItems: "center", ml: 1, fontSize: "1em" }}
            onClick={() => {
                window.open(
                    `/findings?resultId=${finding?.findingDetail?.resultId}`
                    , '_self')
            }}
        >
            <ExternalLink fontSize="inherit" />{" "}
            {finding?.findingDetail?.resultId?.split("-")[0]}
        </Box>
        <Link className="hand" color="primary" sx={{ ml: 1 }} variant="body2" onClick={handleExport}>
            Export
        </Link>

    </Box>}
        children={<Box sx={{pt:2, pb:1}}>
            {finding?.sequence &&
                finding?.sequence?.length
                ? finding?.sequence.map(
                    (step: any, index: number) => (
                        <SequenceStep
                            data={{
                                index,
                                step,
                                isLastStep:
                                    finding?.sequence.length - 1 ===
                                    index,
                            }}
                        />
                    )
                )
                : null}
        </Box>

        } />

}



export default WidgetHandler